import * as tslib_1 from "tslib";
import shouldSkipProcessRow from './helpers/shouldSkipProcessRow';
import { attachmentPreviewOperations } from 'owa-mail-attachment-previews';
import { getRowKeyFromListViewType, MailRowDataPropertyGetter, } from 'owa-mail-list-store';
import TableOperations from 'owa-mail-list-table-operations';
import { getMailboxInfo } from 'owa-mail-mailboxinfo';
import { isRowSortKeyEqual } from './helpers/isSortKeyEqual';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { logVerboseUsage } from 'owa-analytics';
import datapoints from './datapoints';
import { trace } from 'owa-trace';
import { action } from 'satcheljs/lib/legacy';
import { lazyFetchCouponData } from 'owa-mail-coupon-peek';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
export default action('mergeRowResponseFromTop')(
/**
 * Process FindConversation/FindItem response and merge them to the top of the given TableView
 * @param rows to be merged
 * @param tableView to merge results in
 * @param totalRowsInViewInResponse - total rows in the table returned from server
 * @param removeRemainingRowsAfterMerge - flag indicating whether to remove the remaining rows after the merge
 * @param shouldLoadIsdataUptodate - flag indicating whether to log the isDateUptodate datapoint
 */
function mergeRowResponseFromTop(rows, tableView, totalRowsInViewInResponse, removeRemainingRowsAfterMerge, shouldLogIsDataUptodate) {
    var e_1, _a;
    if (!rows) {
        // VSO 1790: We may have no rows if the server returns an error like:
        // "The mailbox database is temporarily unavailable". Do not throw. Just trace this.
        trace.warn('We need to have a valid list of rows');
        return;
    }
    if (shouldLogIsDataUptodate) {
        var isDataUptodate = true;
        // We only want to compare first 2 rows from the response to determine if the
        // the data we have is up-to-date. Even though this is not 100% correct
        // its a guesstimate that the data would probably be up-to-date if first 2 rows are.
        for (var i = 0; i < Math.min(tableView.rowKeys.length, 2, rows.length); i++) {
            if (tableView.rowKeys[i] != rows[i].InstanceKey ||
                !isRowSortKeyEqual(rows[i], tableView)) {
                isDataUptodate = false;
                break;
            }
        }
        logVerboseUsage(datapoints.MergeFindRowsResponse.datapoint.name, datapoints.MergeFindRowsResponse.datapoint.customData(isDataUptodate));
    }
    var insertIndex = 0;
    var listViewType = tableView.tableQuery.listViewType;
    try {
        for (var rows_1 = tslib_1.__values(rows), rows_1_1 = rows_1.next(); !rows_1_1.done; rows_1_1 = rows_1.next()) {
            var row = rows_1_1.value;
            // Check if conversation should be skipped
            if (shouldSkipProcessRow(row, tableView)) {
                continue;
            }
            var rowKey = getRowKeyFromListViewType(row, listViewType);
            if (TableOperations.containsRowKey(tableView, rowKey)) {
                // If this is an existing row, merge it
                // 1. if tri-smartMergeFindResponse is enabled AND the lastModifiedTimeStamp changed, else only update the position OR
                // 2. if tri-smartMergeFindResponse is not enabled
                if (isMailFeatureEnabled('tri-smartMergeFindResponse') &&
                    MailRowDataPropertyGetter.getLastModifiedTimeStamp(rowKey, tableView) ===
                        row.LastModifiedTime) {
                    TableOperations.updateRowPosition(insertIndex, rowKey, tableView);
                }
                else {
                    TableOperations.updateRow(insertIndex, row, tableView);
                }
            }
            else {
                // Otherwise add new row to list
                TableOperations.addRow(insertIndex, row, tableView);
            }
            insertIndex++;
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (rows_1_1 && !rows_1_1.done && (_a = rows_1.return)) _a.call(rows_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    // VSO - 20814 - Add datapoint to log the freshness of cached table on switch mail folder
    // removeRemainingRowsAfterMerge would be true in case of ReloadTable.
    // For such scenario, it generally indicates that we're out of sync with server, so we need to invalidate
    // remaining items we had after merging the top items
    if (removeRemainingRowsAfterMerge) {
        var processedRowCount = insertIndex;
        var rowKeysLength = tableView.rowKeys.length;
        for (var i = rowKeysLength - 1; i >= processedRowCount; i--) {
            TableOperations.removeRow(tableView.rowKeys[i], tableView);
        }
    }
    // Always update totalRowsInView after making a find request, to allow us to calculate whether this table can load more
    tableView.totalRowsInView = totalRowsInViewInResponse;
    if (getUserConfiguration().UserOptions.ShowInlinePreviews) {
        // Get the attachment previews
        attachmentPreviewOperations.getPreviews(getMailboxInfo(tableView), listViewType);
    }
    if (isControlFeatureEnabled('tri-coupon-peek')) {
        lazyFetchCouponData.import().then(function (fetchCouponData) {
            fetchCouponData(getMailboxInfo(tableView).mailboxId, tableView.tableQuery.listViewType);
        });
    }
});
//# sourceMappingURL=mergeRowResponseFromTop.js.map